import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

// eslint-disable-next-line react/display-name
export default ({ value }: ICellRendererParams) => (
  <>
    {value}
  </>
);
